import { useEffect, useState } from "react";
import { Checkbox, Popup } from "antd-mobile";
import styled from "styled-components";
import { EPayType, payTypeImage, payTypeLabel } from "./types";

const Title = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding: 20px 16px 12px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-top: 1px solid rgb(200, 200, 200);
  cursor: pointer;
`;

const Label = styled.div`
  flex: 1;
  margin-left: 10px;
  font-size: 16px;
`;

const Close = styled.div`
  position: absolute;
  right: 16px;
  top: 14px;
  color: rgb(200, 200, 200);
  cursor: pointer;
`;

const OPTIONS = [EPayType.BANK, EPayType.ALIPAY, EPayType.WECHAT];

type Props = {
  value: number[];
  title?: string;
  visible: boolean;
  setVisible: (v: boolean) => void;
  onSelect: (payTypes: number[]) => void;
};

const SelectPayTypeModal = ({
  value,
  title = "支付方式",
  visible,
  setVisible,
  onSelect,
}: Props) => {
  const [inner, setInner] = useState<number[]>(value || []);

  useEffect(() => {
    if (visible) setInner(value || []);
  }, [value, visible]);

  const toggle = (v: number) => {
    const s = new Set(inner);
    if (s.has(v)) s.delete(v);
    else s.add(v);
    const next = Array.from(s).sort((a, b) => a - b);
    setInner(next);
    onSelect(next);
  };

  return (
    <Popup
      visible={visible}
      onMaskClick={() => setVisible(false)}
      bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, paddingBottom: 40 }}
    >
      <div style={{ position: "relative" }}>
        <Close onClick={() => setVisible(false)}>关闭</Close>
        <Title>{title}</Title>
        {OPTIONS.map((type) => (
          <Row key={type} onClick={() => toggle(type)}>
            <img
              src={payTypeImage(type)}
              alt=""
              width={20}
              height={20}
              style={{ borderRadius: 4 }}
            />
            <Label>{payTypeLabel(type)}</Label>
            <Checkbox checked={inner.includes(type)} />
          </Row>
        ))}
      </div>
    </Popup>
  );
};

export default SelectPayTypeModal;
